<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>下注配置</span>
          <syncVersion :in-method="uploadCdn" :params="params" />

          <!--          <el-button v-permisaction="['config:betConfig:uploadCdn']" :loading="loading" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <clear-cache-apply />
          <sync-data />
        </div>

        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="活动体力限制">
            <el-input v-model.number="formData.actSpinsLimit" style="width: 200px;" placeholder="活动体力限制" />
          </el-form-item>
        </el-form>

        <template>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="默认" name="normalConfig">
              <el-button v-permisaction="['config:betConfig:add']" style="margin-bottom: 10px" type="primary" @click="add('normalConfig')">+</el-button>
              <el-button v-permisaction="['config:betConfig:add']" style="margin-bottom: 10px" type="primary" @click="onSubmit()">保存</el-button>
              <el-table :data="formData['normalConfig']" border stripe>
                <el-table-column prop="bet" label="bet">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.bet" placeholder="bet" />
                  </template>
                </el-table-column>
                <el-table-column prop="levelId" label="等级">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.levelId" placeholder="等级" />
                  </template>
                </el-table-column>
                <el-table-column prop="spins" label="体力">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.spins" placeholder="体力" />
                  </template>
                </el-table-column>
                <el-table-column prop="spinsLimit" label="体力限制">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.spinsLimit" placeholder="体力限制" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot:default="scope">
                    <el-button v-permisaction="['config:betConfig:del']" type="danger" @click="del('normalConfig', scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="超级" name="superBetConfig">
              <el-button v-permisaction="['config:betConfig:add']" style="margin-bottom: 10px" type="primary" @click="add('superBetConfig')">+</el-button>
              <el-button v-permisaction="['config:betConfig:add']" style="margin-bottom: 10px" type="primary" @click="onSubmit('progress')">保存</el-button>
              <el-table :data="formData['superBetConfig']" border stripe>
                <el-table-column prop="bet" label="bet">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.bet" placeholder="bet" />
                  </template>
                </el-table-column>
                <el-table-column prop="levelId" label="等级">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.levelId" placeholder="等级" />
                  </template>
                </el-table-column>
                <el-table-column prop="spins" label="体力">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.spins" placeholder="体力" />
                  </template>
                </el-table-column>
                <el-table-column prop="spinsLimit" label="体力限制">
                  <template v-slot:default="scope">
                    <el-input v-model.number="scope.row.spinsLimit" placeholder="体力限制" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template v-slot:default="scope">
                    <el-button v-permisaction="['config:betConfig:add']" type="danger" @click="del('superBetConfig', scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </template>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg, uploadCdn } from '@/api/config/common-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'BetConfig',
  components: { SyncData, SyncVersion, ClearCacheApply },
  data() {
    return {
      key: 'CrazyBetConfig',
      loading: false,
      name: 'betConfig',
      activeName: 'normalConfig',
      params: { name: 'betConfig', type: 'key' },
      formData: {
        normalConfig: [],
        superBetConfig: [],
        actSpinsLimit: 0
      }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    uploadCdn,
    onSubmit() {
      const keys = ['normalConfig', 'superBetConfig']
      for (const k in keys) {
        const val = keys[k]
        for (const i in this.formData[val]) {
          const data = this.formData[val][i]
          console.log('data', data)
          if (data.bet <= 0) {
            this.msgError('bet不能小于0')
            return
          }

          if (data.levelId <= 0) {
            this.msgError('等级不能小于0')
            return
          }
        }
      }

      const data = JSON.stringify(this.formData)
      // console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateCommonCfg({ data: data, name: this.name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(this.activeName)
          // 成功后需要提示修改tetris_win的配置
          this.$alert(
            'Bet配置已更新，请同步修改方块配置-胜利配置以确保数据一致性。',
            '配置提示',
            {
              confirmButtonText: '知道了',
              type: 'warning'
            }
          )
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: this.name }).then(res => {
        this.formData = res.data
      })
    },
    add(name) {
      this.formData[name].push({
        'bet': 1,
        'levelId': 1,
        'spins': 0,
        'spinsLimit': 0
      })
    },
    del(name, index) {
      this.formData[name] = this.formData[name].filter((res, idx) => {
        return idx !== index
      })
    },
    handleClick(tab, event) {
      // console.log(tab.name, event)
      this.getTables(tab.name)
    }
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     uploadCdn({ name: this.name, type: this.key }).then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>
</style>
